var exports = {
  "Qs": "KeyboardShortcutsCheatsheetModal.module__content___c0hmc3",
  "V0": "KeyboardShortcutsCheatsheetModal.module__sections___c0hmc3",
  "uW": "KeyboardShortcutsCheatsheetModal.module__section___c0hmc3",
  "Gf": "KeyboardShortcutsCheatsheetModal.module__sectionTitle___c0hmc3",
  "wE": "KeyboardShortcutsCheatsheetModal.module__shortcutRows___c0hmc3",
  "J8": "KeyboardShortcutsCheatsheetModal.module__shortcutRow___c0hmc3",
  "hV": "KeyboardShortcutsCheatsheetModal.module__shortcutLabel___c0hmc3",
  "PU": "KeyboardShortcutsCheatsheetModal.module__chipGroups___c0hmc3",
  "al": "KeyboardShortcutsCheatsheetModal.module__chipGroup___c0hmc3",
  "jw": "KeyboardShortcutsCheatsheetModal.module__chip___c0hmc3",
};

module.exports = exports;
